const htmlString =
    "<style>body{margin:0;}</style>" +
    "<script>" +
    "window.setFields = function({ arrival, departure, comment }){" +
    "_ea_onLoad = () => { beko.dataFor(document.querySelector('#Comment')).value(comment); }" +
    "};" +
    "var dataLayer = parent.dataLayer; var google_tag_manager = parent.google_tag_manager;" +
    "var ga = parent.ga; var gtag = parent.gtag; var _gaq = parent._gaq;" +
    "</script>" +
    "<script src='" + process.env.VUE_APP_EASSISTANT_WIDGET_HANDLER_URL + "' defer></script>" +
    "<div class='detailpage'><div id='eassistant' data-id='{{token}}' style='width:100%;text-align:center;'></div></div>";

export default function (token, language) {
    return htmlString.replace("{{token}}", token).replace("{{language}}", language);
}

